module.exports = __webpack_public_path__ + "assets/7263d8bc606bbc47a0a1ce76e78e8b47.woff2";